





































































import { Component, Vue } from 'vue-property-decorator';
import { AccountProfileComponents } from '@/enums/AccountProfileComponents';
import { ElForm } from 'element-ui/types/form';
import { Action } from 'vuex-class';

interface RefsInterface {
    ruleForm: ElForm
}

interface Fields {
    oldPassword: string | null,
    password: string | null,
    passwordRepeat: string | null,

    [key: string]: string | null
}

@Component({
    name: 'AccountProfileChangePassword',
})
export default class AccountProfileChangePassword extends Vue {
    public $refs!: Vue['$refs'] & RefsInterface;

    @Action('user/updatePassword') protected updatePassword!: (passwordData: object) => Promise<unknown>;
    @Action('user/logoutUser') protected logoutUser!: () => void;

    protected ruleForm = {
        oldPassword: '',
        password: '',
        passwordRepeat: '',
    };

    protected rules = {
        oldPassword: [
            {required: true, message: 'Please enter you old password', trigger: 'blur'},
        ],
        password: [
            {validator: this.validatePass, trigger: 'blur'},
        ],
        passwordRepeat: [
            {validator: this.validatePass2, trigger: 'blur'},
        ],
    };

    protected errorMessages: Fields = {
        oldPassword: null,
        password: null,
        passwordRepeat: null,
    };

    protected isButtonEnabled = true;

    protected submitForm(formName: keyof RefsInterface) {
        for (const key in this.errorMessages) {
            if (this.errorMessages.hasOwnProperty(key)) {
                this.errorMessages[key] = null;
            }
        }
        const form = this.$refs[formName] as ElForm;
        form.validate(async (valid: boolean) => {
            if (valid) {
                this.isButtonEnabled = false;
                await this.updatePassword({
                    oldPassword: this.ruleForm.oldPassword,
                    password: this.ruleForm.password,
                    passwordRepeat: this.ruleForm.passwordRepeat,
                }).then(() => {
                    this.$message.success('Password successfully changed! Please log in with your new password');
                    this.logoutUser();
                    this.$router.push({name: 'Login'});
                }).catch((e) => {
                    e.response.data.errors.forEach((error: { detail: string, source: { pointer: string } }) => {
                        const pointerArray = error.source.pointer.split('/');
                        const pointer = pointerArray[pointerArray.length - 1];
                        this.errorMessages[pointer] = error.detail;
                    });
                    return new Error(e);
                }).finally(() => {
                    this.isButtonEnabled = true;
                });
            } else {
                return false;
            }
        });
    }

    protected toggleComponent(componentName: keyof typeof AccountProfileComponents) {
        this.$emit('toggle-component', AccountProfileComponents[componentName]);
    }

    protected cancelProfileDetails() {
        this.toggleComponent('Edit');
    }

    private validatePass(rule: unknown, value: string, callback: (error?: Error) => {}) {
        if (value === '') {
            callback(new Error('Please input the new password'));
        } else if (value !== this.ruleForm.passwordRepeat) {
            callback(new Error('Password don\'t match!'));
        } else {
            callback();
        }
    }

    private validatePass2(rule: unknown, value: string, callback: (error?: Error) => {}) {
        if (value === '') {
            callback(new Error('Please input the password again'));
        } else if (value !== this.ruleForm.password) {
            callback(new Error('Password don\'t match!'));
        } else {
            callback();
        }
    }
}
